import { RotatingProblemRole } from './RotatingProblemRole'
import { FLAME, MUTED } from './asesoriaTokens'

export function AsesoriaProblemSection() {
    return (
        <section className='mx-auto flex max-w-[1200px] flex-col gap-8 px-6 pb-10 pt-16 md:pt-24'>
            <div className='flex max-w-[760px] flex-col gap-4'>
                <div className={`text-xs font-semibold uppercase tracking-[0.14em] ${FLAME}`}>Problema</div>
                <h2
                    className='m-0 text-[32px] font-extrabold leading-[1.05] tracking-[-0.03em] md:text-[44px]'
                    aria-label='¿Por qué los cocineros, panaderos, pasteleros y hosteleros estáis hechos de otra pasta?'
                >
                    <span aria-hidden='true'>
                        ¿Por qué los <RotatingProblemRole /> estáis hechos de otra pasta?
                    </span>
                </h2>
            </div>
            <div className={`flex max-w-[720px] flex-col gap-5 text-lg leading-relaxed ${MUTED}`}>
                <p className='m-0'>
                    En hostelería se asume que podéis con todo: 18 horas, fines de semana, festivos, y el trabajo por
                    delante de la familia. Es cierto. Y también es cierto que siempre pasa factura.
                </p>
                <p className='m-0'>
                    Ponéis la felicidad del cliente por delante del propio bienestar. Dais de comer a quien hace posible
                    que llevéis el pan a casa. Es un oficio solitario y apasionado: hace falta pasión para no acabar
                    hecho polvo, y ayuda rodearse de quien entiende lo que es.
                </p>
                <p className='m-0'>
                    En Tipi lo sabemos: también somos hosteleros y cocineros. Queremos cubriros la espalda en la gestión
                    del negocio, para que vosotros os centréis en cocinar, cuidar al cliente y seguir abiertos el tiempo
                    que queráis.
                </p>
            </div>
        </section>
    )
}
